<template>
  <v-card class="mb-8" elevation="0">
    <v-card-text>
      <div class="subtitle-1 font-weight-bold mb-4">
        <v-icon left>mdi-account-cash</v-icon>
        {{ $t("who_pays_title") }}
      </div>

      <div>
        <selectable-card
          v-for="(type, index) in whoPaysTypes"
          :key="type.value"
          :value="type.value"
          :current-value="config.payment_logic.active"
          :icon="type.icon"
          :icon-color="type.color"
          :title="$t(type.i18nKey)"
          :description="$t(type.descKey)"
          :last="index === whoPaysTypes.length - 1"
          @select="config.payment_logic.active = $event"
        >
          <!-- Slot za split -->
          <div class="mt-3 ml-8" v-if="type.value === 'split'">
            <v-row>
              <v-col cols="12" sm="4">
                <dropdown
                  v-model="config.payment_logic.settings.split_by_percentage"
                  :label="$t('split_logic')"
                  :items="splitLogicOptions"
                  :hint="$t('split_logic_hint')"
                  persistent-hint
                  hide-details
                />
              </v-col>
            </v-row>
            <v-expand-transition>
              <v-row
                v-if="config.payment_logic.settings.split_by_percentage"
                class="mt-2"
              >
                <v-col cols="12" sm="4" lg="3" xl="2">
                  <text-field
                    v-model="config.payment_logic.settings.company_share"
                    @input="onCompanyShareInput"
                    :label="$t('company_percentage')"
                    type="number"
                    suffix="%"
                  />
                </v-col>
                <v-col cols="12" sm="4" lg="3" xl="2">
                  <text-field
                    v-model="config.payment_logic.settings.user_share"
                    @input="onUserShareInput"
                    :label="$t('user_percentage')"
                    type="number"
                    suffix="%"
                  />
                </v-col>
              </v-row>
            </v-expand-transition>
            <v-expand-transition>
              <v-row
                v-if="!config.payment_logic.settings.split_by_percentage"
                class="mt-2"
              >
                <v-col cols="12" sm="4">
                  <text-field
                    v-model="config.payment_logic.settings.threshold"
                    :label="$t('company_pays_up_to')"
                    type="number"
                    :suffix="restaurantCurrency"
                    :hint="$t('above_this_amount_user_pays')"
                    persistent-hint
                  />
                </v-col>
              </v-row>
            </v-expand-transition>
          </div>

          <!-- Slot za company_payroll_deduct -->
          <div class="mt-3 ml-8" v-else-if="type.value === 'company_payroll_deduct'">
            <v-row>
              <v-col cols="12" sm="6">
                <text-field
                  v-model="config.payment_logic.settings.monthly_cap"
                  :label="$t('max_monthly_deduction')"
                  type="number"
                  :suffix="config.payment_logic.settings.currency"
                  :hint="$t('max_amount_deducted_from_salary_per_month')"
                  persistent-hint
                />
              </v-col>
            </v-row>
          </div>
        </selectable-card>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import SelectableCard from "../cards/SelectableCard.vue";
import { WHO_PAYS_TYPES } from "@/utils/limitHelpers";

export default {
  name: "Step3WhoPays",
  components: {
    SelectableCard,
  },
  props: {
    config: {
      type: Object,
      required: true,
    },
  },
  computed: {
    whoPaysTypes() {
      return WHO_PAYS_TYPES;
    },
    splitLogicOptions() {
      return [
        {
          text: this.$t("amount_above_limit_user_pays"),
          value: 0,
        },
        { text: this.$t("percentage_split"), value: 1 },
      ];
    },
  },
  methods: {
    normalizeShare(value) {
      const parsed = Number(value);
      if (Number.isNaN(parsed)) return 0;
      return Math.max(0, Math.min(100, parsed));
    },
    onCompanyShareInput(value) {
      const companyShare = this.normalizeShare(value);
      this.config.payment_logic.settings.company_share = companyShare;
      this.config.payment_logic.settings.user_share = 100 - companyShare;
    },
    onUserShareInput(value) {
      const userShare = this.normalizeShare(value);
      this.config.payment_logic.settings.user_share = userShare;
      this.config.payment_logic.settings.company_share = 100 - userShare;
    },
  },
};
</script>
